import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(_theme => ({
  stratifiedResistanceGraph: {
    display: 'flex',
    flexDirection: 'column',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    paddingTop: '12px',
  },
  controlsRow: {
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    marginBottom: '12px',
  },
  control: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '11px',
  },
  controlLabel: {
    fontSize: '10px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: '#666',
    marginBottom: '4px',
  },
  chartArea: {
    width: '100%',
    overflowY: 'auto',
    maxHeight: '520px',
    paddingRight: '4px',
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '180px 1fr 130px',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '6px',
    fontSize: '13px',
  },
  label: {
    textAlign: 'right',
    color: '#333',
    fontWeight: 500,
    fontSize: '13px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  barWrap: {
    background: '#f0f0f3',
    borderRadius: '4px',
    height: '26px',
    position: 'relative',
    overflow: 'hidden',
  },
  bar: {
    height: '100%',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    color: '#fff',
    fontWeight: 600,
    fontSize: '12px',
    textShadow: '0 0 2px rgba(0,0,0,0.3)',
    transition: 'width 0.4s ease',
  },
  meta: {
    fontSize: '11px',
    color: '#666',
    textAlign: 'right',
  },
  axis: {
    display: 'grid',
    gridTemplateColumns: '180px 1fr 130px',
    gap: '10px',
    fontSize: '10px',
    color: '#888',
    marginTop: '4px',
    paddingTop: '4px',
    borderTop: '1px solid #e0e0e3',
  },
  axisTicks: {
    display: 'flex',
    justifyContent: 'space-between',
    gridColumn: 2,
  },
  footer: {
    marginTop: '12px',
    paddingTop: '10px',
    borderTop: '1px solid #e0e0e3',
    fontSize: '11px',
    color: '#666',
    lineHeight: 1.5,
  },
  emptyState: {
    padding: '32px',
    textAlign: 'center',
    color: '#888',
    fontSize: '13px',
  },
}));
